"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const TpdErrors_service_1 = require("../../providers/TpdErrors.service");
const react_1 = require("react");
const TpdErrors_style_1 = require("./TpdErrors.style");
const TpdErrors = (props) => {
    const { blueVersion, customMessageRecuperaPreventivo, title, customMessageFromComponent, messageToDisplay, showButtonBack, chain = true, reload = false, textReload = 'AGGIORNA', mini, message, hideRefreshButton, back, redirectToCustomUrl, pType, errorId, redirectTo = "/", } = props;
    //
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const [customMessageFlag, setCustomMessageFlag] = (0, react_1.useState)(false);
    const _errorService = new TpdErrors_service_1.TpdErrorsService();
    (0, react_1.useEffect)(() => {
        const subscription = _errorService
            .getMsgObservable()
            .subscribe((errorCode) => {
            const msg = errorCode;
            if (msg) {
                setCustomMessageFlag(true);
                setErrorMessage(msg);
            }
        });
        if (typeof message != "undefined" &&
            message &&
            message != "") {
            setErrorMessage(message);
            setCustomMessageFlag(true);
        }
        else {
            setErrorMessage("Stiamo già lavorando per ripristinare la normale operatività appena possibile.<br>" +
                "Ci scusiamo per il disagio.");
        }
        return () => {
            subscription.unsubscribe();
        };
    }, []);
    const goToHomepage = () => {
        const backToHomePage = true;
        nodejs_library_1.Helpers.SessionHelper.setData("backToHomePage", backToHomePage.toString())
            .then(() => {
            if (typeof window === "object") {
                window.location.replace("/homepage#calcolaPreventivo");
            }
        })
            .catch(() => {
            if (typeof window === "object") {
                window.location.replace("/homepage#calcolaPreventivo");
            }
        });
    };
    const sendErrorNotification = () => __awaiter(void 0, void 0, void 0, function* () {
        const name = "aggiorna";
        const effect = "ritorno a step 1";
        if (pType == "auto" || pType == "moto") {
            yield callActionOtherPreventivoAnalytics(name, effect);
        }
        if (typeof errorId != "string") {
            console.error("Controlla di aver inserito lerrorId con gli apici singoli come : [errorId]=\"'error-id-esempio'\"");
            return;
        }
        props.onErrorReload();
        //_errorService.sendErrorNotification(errorId);
    });
    const redirect = () => {
        const name = "calcola altri preventivi";
        const effect = "calcolo altri preventivi";
        if (pType == "auto" || pType == "moto") {
            callActionOtherPreventivoAnalytics(name, effect);
        }
        if (typeof location === "object") {
            if (redirectToCustomUrl) {
                nodejs_library_1.Helpers.RouterHelper.goTo(redirectToCustomUrl, {
                    openNewTab: false,
                });
            }
            nodejs_library_1.Helpers.RouterHelper.goTo(redirectTo, {
                openNewTab: false,
            });
        }
    };
    const goBack = (url) => {
        if (typeof window === "object") {
            nodejs_library_1.Helpers.RouterHelper.goTo(url, {
                openNewTab: false,
            });
        }
    };
    const callActionOtherPreventivoAnalytics = (name, effect) => __awaiter(void 0, void 0, void 0, function* () {
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            try {
                const timestamp = getFormattedDate();
                let click = "0";
                let formType;
                if (document.getElementsByClassName("bk_002").length != 0) {
                    formType = "sticky";
                }
                else if (document.getElementsByClassName("mbk_054_box_full_width").length != 0) {
                    formType = "full_page";
                }
                if (document.getElementsByClassName("on_tpd_search").length != 0) {
                    click = "1";
                }
                const analyticsPart = {
                    virtual: "action",
                    action_name: name,
                    action_tech: "click",
                    action_type: "calcolo preventivo",
                    action_timestamp: timestamp,
                    action_element_position: "body",
                    action_effect: effect,
                    results_sticky_click: click,
                    action_form_type: formType,
                };
                const userCrmIdStorage = yield nodejs_library_1.Helpers.SessionHelper.getData("user_crm_id").catch(() => null);
                analyticsPart["user_crm_id"] = userCrmIdStorage ? userCrmIdStorage : "";
                const analyticsService = nodejs_library_1.Providers.AnalyticsService.getInstance();
                analyticsService.triggerLink(analyticsPart);
            }
            catch (e) {
                console.error(e);
            }
        }
    });
    const getFormattedDate = () => {
        const date = new Date();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const min = date.getMinutes();
        const sec = date.getSeconds();
        const monthStr = (month < 10 ? "0" : "").concat(month.toString());
        const dayStr = (day < 10 ? "0" : "").concat(day.toString());
        const hourStr = (hour < 10 ? "0" : "").concat(hour.toString());
        const minStr = (min < 10 ? "0" : "").concat(min.toString());
        const secStr = (sec < 10 ? "0" : "").concat(sec.toString());
        const str = `${date.getFullYear()}-${monthStr}-${dayStr} ${hourStr}:${minStr}:${secStr}`;
        return str;
    };
    return ((0, jsx_runtime_1.jsx)(TpdErrors_style_1.TpdErrorsContainer, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `col-xs-24 tpd-errors
                    ${mini ? "tpd-errors-mini" : ""}
                    ${blueVersion ? "tpd-errors-blue" : ""}
            ` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `box-error-content
                        ${customMessageRecuperaPreventivo ? "box-error-content-margin" : ""}
                ` }, { children: [chain && (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("i", { className: "icon-Broken-link" }) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "tpd-title add-margin-y", "aria-label": title, role: "alert" }, { children: title })), customMessageFromComponent &&
                        (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "title" }, { children: "Attenzione" })), (0, jsx_runtime_1.jsx)("div", { className: "subtitle", dangerouslySetInnerHTML: { __html: customMessageFromComponent }, "aria-label": customMessageFromComponent, role: "alert" }), (0, jsx_runtime_1.jsx)("div", { className: "subtitle", dangerouslySetInnerHTML: { __html: messageToDisplay || '' } })] }), customMessageRecuperaPreventivo &&
                        (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "title" }, { children: "Attenzione" })), (0, jsx_runtime_1.jsx)("div", { className: "subtitle", dangerouslySetInnerHTML: { __html: messageToDisplay || '' } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "tpd_error_component_button" }, { children: showButtonBack ? ((0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: goToHomepage }, { children: "CALCOLA PREVENTIVO" }))) : ((0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: sendErrorNotification }, { children: textReload }))) }))] }), (!customMessageFromComponent && !customMessageRecuperaPreventivo) &&
                        (0, jsx_runtime_1.jsxs)("div", { children: [!customMessageFlag && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "title" }, { children: "Servizio momentaneamente non disponibile" }))), (0, jsx_runtime_1.jsx)("div", { className: "subtitle", dangerouslySetInnerHTML: { __html: errorMessage || '' }, "aria-label": errorMessage, role: "alert" })] }), (reload && !customMessageRecuperaPreventivo) &&
                        (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "tpd_error_component_button" }, { children: [!hideRefreshButton && !back && ((0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: sendErrorNotification, style: { marginRight: '20px' } }, { children: textReload }))), back && ((0, jsx_runtime_1.jsxs)("button", Object.assign({ onClick: () => goBack(back.url) }, { children: ["Torna ", back.nomeBottone ? `in ${back.nomeBottone}` : 'indietro'] }))), (redirectTo || redirectToCustomUrl) && ((0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: redirect }, { children: "CALCOLA ALTRI PREVENTIVI" })))] }))] })) })) }));
};
exports.default = TpdErrors;
